import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
export const TileTableCell = (props) => {
    const { children, className = '', headText = '' } = props;
    return (_jsxs("div", Object.assign({ className: clsx('w-full', 'flex flex-col items-center gap-y-8', 'border-r border-l-0 border-y-0 border-solid border-dark', 'px-8', className) }, { children: [headText && (_jsx(Text, Object.assign({ className: 'text-center', color: 'primary', isBold: true, size: 'sm' }, { children: headText }))), children] })));
};
